var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-center',{scopedSlots:_vm._u([{key:"page",fn:function(){return [_c('h1',[_vm._v(" "+_vm._s(_vm.message)+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }